import React from "react";
import {IEvent, IGame} from "@webng-types/write-model";
import {LiveblogGameSummaryGroup} from "../LiveblogGameSummaryGroup";
import {LiveblogGameSummaryPhaseSeparator} from "../LiveblogGameSummaryPhaseSeparator";

function showPhaseLabelsForGame(game: IGame): boolean {
  return (
    (game.options?._type === "Tik::Model::Options::TimedGameOptions" ||
      game.options?._type === "Tik::Model::Options::CountingGameOptions") &&
    (game.options.timing_type === "u" || game.options.timing_type === "d")
  )
}

function phaseKeyForEvent(e: IEvent): string | null {
  return e.sport_event?.phase?._id ?? e.sport_event?.phase?.name ?? null
}

function canRenderGameSummaryEvent(event: IEvent): boolean {
  const player = event.sport_event?.players?.find(p => p.event_player_type === 'scorer')?.player
  const team = event.sport_event?.team
  const time_of_play = event.sport_event?.time_of_play

  return !event.sport_event?.is_cancelled && !!player && !!team && !!time_of_play
}

export function buildGameSummaryPhaseGroups(
  events: IEvent[],
  game: IGame,
  renderItem: (event: IEvent) => React.ReactNode
): React.ReactNode[] {
  const multiPhase =
    showPhaseLabelsForGame(game)

  const groups: React.ReactNode[] = []
  let currentGroupItems: React.ReactNode[] = []
  let currentPhaseKey: string | null | undefined = undefined
  events.filter(canRenderGameSummaryEvent).forEach(event => {
    const key = phaseKeyForEvent(event)
    if (multiPhase && key !== currentPhaseKey) {
      currentPhaseKey = key
      currentGroupItems = []
      groups.push(<LiveblogGameSummaryGroup key={"group" + currentPhaseKey}>{currentGroupItems}</LiveblogGameSummaryGroup>)

      const phaseName = event.sport_event?.phase?.name
      if (phaseName) {
        currentGroupItems.push(<LiveblogGameSummaryPhaseSeparator key={"sep" + key} label={phaseName} />)
      }
    }
    currentGroupItems.push(renderItem(event))
  })

  // push one group if not multiphase
  if(!multiPhase){
    groups.push(<LiveblogGameSummaryGroup key={"group" + currentPhaseKey}>{currentGroupItems}</LiveblogGameSummaryGroup>)
  }

  return groups
}
